
import React from 'react'
import { useSelector } from 'react-redux'

export const useGetCustomsOfficeDS=()=> useSelector((state) => state.Shipment.customsOffice);